module.exports = { raw: '8.12.3' };



//////////////////
// WEBPACK FOOTER
// ./~/auth0-js/src/version.js
// module id = FWbe
// module chunks = 0